import React, { useEffect, useRef, useState } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

const TawkWidget = ({ _key, canViewChat, onChatMaximized }) => {
  const [shouldHideChat, setShouldHideChat] = useState(false);
  const [tawkToLoaded, setTawkToLoaded] = useState(false);
  const tawkMessengerRef = useRef();
  const tawkToPropertyId = window.TAWK_TO_PROPERTY || "";
  const tawkWidgetId = window.TAWK_TO_KEY || "";
  const hideTwak = window.HIDE_TAWK || false;

  useEffect(() => {
    if(hideTwak) {
      setShouldHideChat(true)
    }else{
      setShouldHideChat(canViewChat.some(item => item === true));
    }
  }, []);

  useEffect(() => {
    if (shouldHideChat && tawkToLoaded && tawkMessengerRef.current) {
      tawkMessengerRef.current.hideWidget();
    }
  }, [shouldHideChat, tawkToLoaded]);

  // useImperativeHandle(ref, () => ({
  //   hideWidget: () => {
  //     if (tawkMessengerRef.current) {
  //       tawkMessengerRef.current.hideWidget();
  //     }
  //   },
  //   showWidget: () => {
  //     if (tawkMessengerRef.current) {
  //       tawkMessengerRef.current.showWidget();
  //     }
  //   },
  // }));

  return (
    <>
      {tawkToPropertyId && tawkWidgetId && (
        <TawkMessengerReact
          key={_key}
          onLoad={() => {
            setTawkToLoaded(true);
          }}
          ref={tawkMessengerRef}
          propertyId={tawkToPropertyId}
          widgetId={tawkWidgetId}
          onChatMaximized={onChatMaximized}
        />
      )}
    </>
  );
};

export default TawkWidget;
